<div class="or-content-body">
  <div class='mb-12'>
    <form #form
          [formGroup]="fg"
          name="auditForm"
          data-cy='audit-form'
    >
      <div class='lg:container lg:mx-auto'>
        <div class='flex sm:flex-row flex-col'>
          <div class="basis-1 sm:basis-8/12">
            <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2'>
              <mat-label data-cy='siem-form-uri-label'>URI</mat-label>
              <input data-cy='siem-form-uri' type='text' matInput #uri
                     data-test="form-siem-uri" formControlName="uri" />
              <mat-hint class='text-gray-500' align="end">{{uri?.value?.length}} /  {{ _maxLength }}</mat-hint>
            </mat-form-field>
            <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2'>
              <mat-label data-cy='siem-form-log-authorization-label'>Log Authorization</mat-label>
              <mat-select data-cy='siem-form-log-authorization-select' #logAuthorization formControlName="logAuthorization" data-test="form-siem-logAuthorization">
                <mat-option value='BEARER_TOKEN'>Bearer Token</mat-option>
                <mat-option value='AUTHORIZATION_HEADER'>Authorization Header</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
              <mat-label data-cy='siem-form-log-format-label'>Log format</mat-label>
              <mat-select data-cy='siem-form-log-format-select' #logFormat formControlName="logFormat" data-test="form-siem-logFormat">
                <mat-option value='SENTINEL_LOG'>Sentinel Log format (JSON Array)</mat-option>
                <mat-option value='CEF'>Common Event Format (PLAIN_TEXT, Line delimited)</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- OAuth Specific Fields -->
            @if (logAuthorization?.value === "BEARER_TOKEN") {
              <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
                <mat-label data-cy='siem-form-client-id-label'>Client ID</mat-label>
                <input data-cy='siem-form-client-id' type='text' matInput #clientId
                       data-test="form-siem-client-id" formControlName="clientId" />
                <mat-hint class='text-gray-500' align="end">{{clientId?.value?.length}} /  {{ _maxLength }}</mat-hint>
              </mat-form-field>
            }

            <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
              @if (logAuthorization?.value === "BEARER_TOKEN") {
                <mat-label data-cy='siem-form-client-secret-label'>Client Secret</mat-label>
              }
              @if (logAuthorization?.value === "AUTHORIZATION_HEADER") {
                <mat-label data-cy='siem-form-authorization-header-label'>Authorization Header</mat-label>
              }
              <input data-cy='siem-form-client-secret' type='password' matInput #clientSecret
                     data-test="form-siem-client-secret" formControlName="clientSecret" />
              <mat-hint class='text-gray-500' align="end">{{clientSecret?.value?.length}} /  {{ _maxLength }}</mat-hint>
            </mat-form-field>

            @if (logAuthorization?.value === "BEARER_TOKEN") {
              <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
                <mat-label data-cy='siem-form-scope-label'>OAuth Scope</mat-label>
                <input data-cy='siem-form-scope' type='text' matInput #scope
                       data-test="form-siem-scope" formControlName="scope" />
                <mat-hint class='text-gray-500' align="end">{{scope?.value?.length}} /  {{ _maxLength }}</mat-hint>
              </mat-form-field>
            }

            @if (logAuthorization?.value === 'BEARER_TOKEN') {
              <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
                <mat-label data-cy='siem-form-authentication-url-label'>OAuth Authentication URI</mat-label>
                <input data-cy='siem-form-authentication-url' type='text' matInput #authenticationUrl
                       data-test="form-siem-authentication-url" formControlName="authenticationUrl" />
                <mat-hint class='text-gray-500' align="end">{{authenticationUrl?.value?.length}} /  {{ _maxLength }}</mat-hint>
              </mat-form-field>
            }

            <!-- Log output format -->
            @if (logFormat?.value === "CEF") {
              <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
                <mat-label data-cy='siem-form-syslog-label'>Syslog Format</mat-label>
                <mat-select data-cy='siem-form-syslog-select' #syslog formControlName="syslog" data-test="form-siem-syslog">
                  <mat-option [value]=true>Yes</mat-option>
                  <mat-option [value]=false>No</mat-option>
                </mat-select>
              </mat-form-field>
            }

            <div class='w-full md:w-10/12 flex md:flex-row flex-col sm:ml-2 sm:mt-2'>
              <button
                data-cy='service-level-form-reset'
                class='w-full sm:w-10/12 md:w-1/2 md:mr-6 mb-4'
                (click)="reset()"
                mat-raised-button
                color='accent'
                data-test="form-service-level-reset"
                [disabled]="fg.pristine"
              >
                <span class="or-icon or-small or-icon-reload"></span>
                <span>Reset</span>
              </button>
              <button
                data-cy='service-level-form-submit'
                mat-raised-button
                data-test="form-service-level-submit"
                class="w-full sm:w-10/12 md:w-1/2"
                color='primary'
                type="submit"
                (click)="submit()"
                [disabled]="fg.disabled || fg.invalid || fg.pristine"
              >
                <span class="or-icon or-small or-inverse or-icon-checkmark"></span>
                <span class="or-button-label" data-cy='service-level-form-submit-label'>Save</span>
              </button>

            </div>

            @if (fg.invalid) {
              <div class="cross-validation-error-message alert alert-danger">
                @for (error of getFormValidationErrors(); track error) {
                  <app-notification-block
                    [header]="error"
                    [statusClass]="StatusClass.ERROR">
                  </app-notification-block>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Connections section — only visible to users with MANAGE_BUILDINGS authority -->
  <div [appIsAuthorized]="GlobalAuthority.MANAGE_BUILDINGS">
    <mat-divider></mat-divider>
    <form [formGroup]="connectionsForm"
          name="connectionsForm"
          data-cy="connections-form"
    >
      <div class='lg:container lg:mx-auto'>
        <div class='flex sm:flex-row flex-col'>
          <div class="basis-1 sm:basis-8/12">
            <mat-form-field appearance='fill' class='w-full sm:w-10/12 md:w-5/12 sm:ml-2 sm:mt-2'>
              <mat-label data-cy='connections-form-label'>Connections</mat-label>
              <mat-select
                data-cy='connections-form-select'
                data-test="form-connections"
                formControlName="connections"
                multiple
              >
                @for (connection of availableConnections; track connection.name) {
                  <mat-option [value]="connection.name">{{ connection.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <div class='w-full md:w-10/12 flex md:flex-row flex-col sm:ml-2 sm:mt-2'>
              <button
                data-cy='connections-form-reset'
                mat-raised-button
                data-test="form-connections-reset"
                class="w-full sm:w-10/12 md:w-1/2 md:mr-6 mb-4"
                color='accent'
                type="button"
                (click)="resetConnections()"
                [disabled]="savingConnections || connectionsForm.pristine"
              >
                <span class="or-icon or-small or-icon-reload"></span>
                <span>Reset</span>
              </button>
              <button
                data-cy='connections-form-submit'
                mat-raised-button
                data-test="form-connections-submit"
                class='w-full sm:w-10/12 md:w-1/2'
                color='primary'
                type="button"
                (click)="submitConnections()"
                [disabled]="savingConnections || connectionsForm.invalid || connectionsForm.pristine"
              >
                <span class="or-icon or-small or-inverse or-icon-checkmark"></span>
                <span class="or-button-label" data-cy='connections-form-submit-label'>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

